export default __webpack_public_path__ + "static/media/t3.6dc6c32f.jpg";